<style lang='scss'>
	#tui-home{
		.ant-modal-header, .ant-modal-body{
			border-radius:0 !important;
		}
		.ant-modal-header{
			display: none;
			z-index: 0;
		}
		.ant-modal {
			top: 10vh;
		}
		.ant-modal-header, .ant-modal-body{
			background-color: #e5e5e5 !important;
			padding: 1rem;
			padding-top: .7rem;
		}
		.main-hand-title{
			position: absolute;
			top: 0;
			left: 0;
			div{
				font-size: 1rem;
				padding: .8rem 1rem .2rem 1rem;
				background-color:  #e5e5e5;
			}
		}
		.wland{
			display: inline-block;
			width: 7rem;
			padding: .4rem 0 .6rem;
			text-align: center;
			background-color: #fff;
			color: #000;
			border-top: .2rem solid #e99c00;
			border-right: 1px solid #e5e5e5;
			font-size: .8rem;
		}
		.gland{
			display: inline-block;
			width: 7rem;
			padding: .6rem 0;
			text-align: center;
			background-color: #0c8b97;
			color: #fff;
			font-size: .8rem;
			border-right: 1px solid #e5e5e5;
		}
	}
	
	#tubody-tui>div{
		padding: 1px 0;
	}
	
	#tubody-tui{
		background-color: #fff;
		.main-mybody{
			padding: .5rem 1.5rem 0;
			/* overflow-y: auto; */
			min-height: 30rem;
		}
		
		.ant-empty-normal{
				margin: 7rem 0;
		}
		.look_tuijian{
			font-size: .8rem;
			margin-bottom: 1rem;
			div{
				display: inline-block;
				width: 8rem;
				height: .9rem;
				position: relative;
				top: .1rem;
				margin-right: .2rem;
				border-left: 0;
				color: #000;
				img{
					width: .8rem;
				}
			}
		}
		
		.main-wid{
			width: 100%;
			height: 1px;
			border-top: .5px solid #d8d8d8;
			margin: 1rem 0;
		}
		
		.ant-col {
			font-size: .8rem;
			color: #000;
			margin: .4rem 0;
		}
		
		.btn{
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			font-size: 0.8rem;
			color: #fff;
			border: 0;
			border-radius: 5px;
			text-align: center;
			line-height: 2rem;
			background-color: #0c8b97;
			margin: 1rem;
		}
		
		.warp_daochu{
			display: flex;
			justify-content: space-between;
			padding: 0rem .5rem .5rem;
			div{
				font-size: .7rem;
			}
		}
	}
	
	.headtop{
		z-index: 8000;
	}
</style>
<template>
	<div>
		<a-modal
		width='63rem'
		id='tui-home'
		title='title'
		v-model='visible'
		@on='handleOk'
		@cancel='handleCancel'
		:footer="null" 
		:keyboard='false'
		:maskClosable='false'>
			<div class='main-hand-title' style="z-index: 1;display: none;">
				<div style="position: relative;top: .44rem;">
					{{itemobj.name}}, {{itemobj.number}}
				</div>
			</div>
			<div class='headtop' style="margin-top: .3rem;">
				<div v-for='(item,ind) in titlearr' :key='ind + "0716"' 
				:class='island == item.component?"wland":"gland"' @click="fanfn(item)">
					{{item.name}}
				</div>
			</div>
			<div id='tubody-tui' class='headtop'>
				<component :is='island' :itemobj='itemobj' :ref='island'></component>
				<div>
					<div style="width: 100%;height: 1px;border-bottom: 1px solid rgb(232, 232, 232);margin-bottom: .4rem;"></div>
					<div class='warp_daochu'>
						<div style="padding-left: .5rem;">
							<div style="font-size: .85rem;font-weight: 500;color: #000;">溫馨提示</div>
							<div>1. 查詢起止時間最長為六個月。通常邀請查詢可查詢改邀請人最近六個月的所有邀請記錄。</div>
							<div>2. 用於查詢該邀請人的所有邀請記錄，並可對邀請記錄詳情就行導出。</div>
						</div>
						<div class='btn' @click='handexcel'>導 出</div>
					</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import weitijao from './weitijao.vue'
	import yitijiao from './yitijiao.vue'
		
	export default {
		name:'handhome',
		props:['itemobj'],
		components:{
			yitijiao,
			weitijao
			},
		data(){
			return {
				visible:true,
				island: 'yitijiao',
				titlearr:[
					{
						name:'已提交開户',
						component:'yitijiao',
						island:true
					},{
						name:'未提交開户',
						component:'weitijao',
						island:false
					}
				]
			}
		},
		mounted() {
		},
		methods:{
			handexcel(){
				let str = ''
				if(this.island == 'yitijiao'){
					str = this.$api.SubmittedKh
				}else if(this.island == 'weitijao'){
					str = this.$api.Unsubmit
				}
				let obj = this.$refs[this.island].getfn()
				// obj.inviterid = this.itemobj.inviterid
				let urls = '?inviterid=' + this.itemobj.inviterid
				urls+='&token=' + this.$store.state.token + '&m=' + Date.parse(new Date())
				for(let key in obj){
						urls += '&'+ key+'='+obj[key]
				}
				// window.location.href  = str + urls
				console.log(urls)
				this.$ajax({
					method: 'get',
					url: str+urls,
					responseType: 'blob'
				}).then(res => {
					const BLOB = res.data; // Blob 对象表示一个不可变、原始数据的类文件对象（File 接口都是基于Blob）
					      const fileReader = new FileReader(); // FileReader 对象允许Web应用程序异步读取存储在用户计算机上的文件的内容
					      fileReader.readAsDataURL(BLOB); // 开始读取指定的Blob中的内容。一旦完成，result属性中将包含一个data: URL格式的Base64字符串以表示所读取文件的内容
						  console.log(fileReader)
					      fileReader.onload = (event) => { // 处理load事件。该事件在读取操作完成时触发
						  console.log(event)
					        // 新建个下载的a标签，完成后移除。
					        let a = document.createElement('a');
					        a.download = this.island == 'yitijiao'?`已提交開户.xls`:`未提交開户.xls`;
					        a.href = event.target.result; 
					        document.body.appendChild(a);
					        a.click();
					        document.body.removeChild(a);}
				},err=>{
					// this.$message.warning(res.data)
				}).catch(res=>{
					// this.$message.warning(res.data.qmismsg)
				})
				
			},
			fanfn(item){
				this.island = item.component;
			},
			handleOk(){
				
			},
			handleCancel(){
				this.$emit('child', 0)
			},
		}
	}
</script>
